import { HttpClientHelper } from './../helpers/HttpClientHelper';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CurrentUser } from '../models/current-user.model';
import { AppConfig } from '../app.config';
import { SkeletonJobAlert } from '../components/search/jbe-custom-modal/models';
import { HttpParameter } from '../datatypes/misc';

@Injectable()
export class AuthenticationService {

    token: string;
    user: string;
    isUserLoggedin = new BehaviorSubject<boolean>(false);

    constructor(private httpClient: HttpClient, private httpClientHelper: HttpClientHelper) {}

    login(username: string, password: string): Observable<any>
    {

        const header = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: header, withCredentials: true };
        const body = `{"username": "${username}","password": "${password}"}`;

        const url = AppConfig.getUrl('AUTH.TOKEN');

        return this.httpClient.post<CurrentUser>(url, body, options);
    }

    logout() {
        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders, withCredentials: true };

        return this.httpClientHelper.httpGet(new HttpParameter('Account.Logout', [], null, '', options));
    }

    emailVerifiy(userId: string, code: string): Observable<boolean> {
        const xcode: string = encodeURI(code);
        const url = AppConfig.getUrl('Confirm.Candidate') + '?userId=' + userId + '&code=' + xcode;
        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders};

        return this.httpClient.get<boolean>(url, options);
    }

    changeEmailVerifiy(userId: string, code: string): Observable<boolean> {
        const xcode: string = encodeURI(code);
        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders};

        return this.httpClient.get<boolean>(AppConfig.getUrl(
            'Confirm.EmailChange') + '?userId=' + userId + '&code=' + xcode, options);
    }

    resendVerificationEmail(userId: string, email: string): Observable<boolean> {
        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders};
        const url = AppConfig.getUrl('ResendVerificationEmail.Candidate') + '?userId=' + userId + '&email=' + email;

        return this.httpClient.get<boolean>(url, options);
    }

    resendVerificationEmailAndCreateJobAlert(dto: SkeletonJobAlert, userId: string, email: string): Observable<boolean> {
        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders};
        const url = AppConfig.getUrl('ResendVerificationEmailAndCreateJobAlert.Candidate') + '?userId=' + userId + '&email=' + email;

        return this.httpClient.post<boolean>(url, dto, options);
    }

    resendChangeEmailVerification(userId: string): Observable<boolean> {
        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders};
        const url = AppConfig.getUrl('Candidate.ResendChangeEmailVerification') + '?userId=' + userId;

        return this.httpClient.get<boolean>(url, options);
    }

    resetPassword(userId: string, token: string, password: string) {
        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders};
        const url = AppConfig.getUrl('ResetPassword.Candidate') + '?userId=' + userId + '&token=' + token + '&password=' + password;

        return this.httpClient.get<boolean>(url, options);
    }

    requestPasswordReset(email: string): Observable<boolean> {
        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders};
        const url = AppConfig.getUrl('RequestPasswordReset.Candidate') + '?email=' + email;

        return this.httpClient.get<boolean>(url, options);
    }

    confirmEmailVerifyToken(email: string, token: string, purpose: string, userId?: string): Observable<boolean> {
        const dto = {
            email,
            token,
            purpose,
            userId
        };

        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders };
        const url = AppConfig.getUrl('Account.ConfirmEmailVerifyToken');

        return this.httpClient.post<boolean>(url, dto, options);
    }

    verifyActiveToken(): Observable<boolean> {

        const myHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: myHeaders };
        const url = AppConfig.getUrl('Account.VerifyActiveToken');

        return this.httpClient.get<boolean>(url, options);
    }


}
